import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@/components/ThemeProvider";
import { LanguageProvider } from "@/contexts/LanguageContext";

// Components
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";

// Pages
import Index from "@/pages/Index";
import AboutPage from "@/pages/AboutPage";
import GalleryPage from "@/pages/GalleryPage";
import PressPage from "@/pages/PressPage";
import EventsPage from "@/pages/EventsPage";
import FinalEventPage from "@/pages/FinalEventPage";
import PartnersPage from "@/pages/PartnersPage";
import FAQPage from "@/pages/FAQPage";
import ContactPage from "@/pages/ContactPage";
import NotFound from "@/pages/NotFound";
import BuyTicketPage from "@/pages/BuyTicketPage";

const App = () => (
  <ThemeProvider>
    <LanguageProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <div className="flex flex-col min-h-screen">
            <Navigation />
            <main className="flex-grow">
              <Routes>
                <Route path="/" element={<Index />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/gallery" element={<GalleryPage />} />
                <Route path="/press" element={<PressPage />} />
                <Route path="/events" element={<EventsPage />} />
                <Route path="/final" element={<FinalEventPage />} />
                <Route path="/partners" element={<PartnersPage />} />
                <Route path="/faq" element={<FAQPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/buy-ticket" element={<BuyTicketPage />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </BrowserRouter>
      </TooltipProvider>
    </LanguageProvider>
  </ThemeProvider>
);

export default App;
